<template>
  <div data-app>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="6" md="6" style="color: #e33354" class="ml-4">
            <h3>{{ cardTitle }}</h3>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$t('FORMS.search')"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="enrichedEventCollection"
          :search="search"
          :sort-by="['from']"
          sort-desc="true"
          :loading="loadingTable"
          @click:row="handleClickItem"
          :footer-props="{
            'items-per-page-options': [100],
          }"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <EventModalForm
                :modalData="modalData"
                :permissions="permissions"
                :statuses="statuses"
                :endPoint="endPoint"
                :eventCategoryCollection="eventCategoryCollection"
                @closeModalForm="handleCloseModalForm"
                @saveModalForm="handleSaveModalForm"
                @new="handleNew"
              ></EventModalForm>
              <v-spacer></v-spacer>
              <DeleteModalDialog
                :dialogDelete="dialogDelete"
                @closeDelete="handleCloseDelete"
                @deleteItemConfirm="handleDeleteItemConfirm"
              >
              </DeleteModalDialog>
            </v-toolbar>
          </template>
          <template v-slot:item.translated="{ item }">
            <v-icon v-if="item.translated" color="green" small
              >check_circle</v-icon
            >
          </template>
          <template v-slot:item.tableCategories="{ item }">
            <span v-for="category in item.categories" :key="category.id">
              {{ getEventCategoryByID(category).name }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- <router-link
              :to="`/cms/pages/${item.id}`"
              v-if="permissionCan('view')"
            >
              <v-icon small class="mr-2"> mdi-pencil </v-icon>
            </router-link> -->
            <v-icon
              color="primary"
              v-if="permissionCan('delete')"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SiteService from "@/core/services/site.service.js";

import { listModelsMixins } from "@/view/mixins/listModelsMixins.js";

import EventModalForm, { initialFormData } from "./EventModalForm";

import DeleteModalDialog from "@/view/components/DeleteModalDialog";

export const PERMISSION_TO = "events.event.";

export default {
  name: "Event",
  components: { EventModalForm, DeleteModalDialog },
  mixins: [listModelsMixins],
  data() {
    return {
      cardTitle: this.$t("MENU.EVENTS"),
      search: "",
      routePath: "/cms/event/event/",
      permissionTo: PERMISSION_TO,
      permissions: JSON.parse(localStorage.permissions),
      headers: [
        {
          text: this.$t("TABLE.translated"),
          value: "translated",
          width: "100px",
        },
        {
          text: this.$t("TABLE.name"),
          value: "name",
        },
        // {
        //   text: this.$t("TABLE.created_at"),
        //   value: "created",
        // },
        {
          text: this.$t("TABLE.from"),
          value: "from",
        },
        {
          text: this.$t("TABLE.to"),
          value: "to",
        },
        {
          text: this.$t("TABLE.categories"),
          value: "tableCategories",
        },

        // { text: "Status", value: "status" },
        {
          text: this.$t("TABLE.actions"),
          value: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      modalData: {
        dialog: false,
        editedId: null,
      },
      editedItem: Object.assign({}, initialFormData()),

      dialogDelete: false,
    };
  },

  computed: {
    ...mapGetters([
      "eventCollection",
      "eventCategoryCollection",
      "statuses",
      "getEventCategoryByID",
    ]),
    endPoint() {
      return "events/admin/" + SiteService.getActiveSiteId() + "/event/";
    },
    enrichedEventCollection() {
      return this.eventCollection.map((item) => ({
        ...item,
        tableCategories: (item.categories || [])
          .map((catId) => this.getEventCategoryByID(catId).name)
          .filter(Boolean)
          .join(", "),
      }));
    },
  },

  watch: {
    dialogDelete(val) {
      val || this.handleCloseDelete();
    },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(["fetchEvent", "fetchEventCategory"]),

    handleSaveModalForm(id = null) {
      this.modalData.editedId = null;
      if (id) {
        this.modalData.editedId = id;
      }
      // this.handleCloseModalForm();
    },

    fetchModel() {
      this.fetchEventCategory();
      return this.fetchEvent();
    },
  },

  mounted() {
    this.loadingTable = true;
    this.fetchModel().then(() => (this.loadingTable = false));
  },
};
</script>
